import { useState, useEffect } from 'react';

interface FeatureFlags {
  organizations: boolean;
  advanced_payments: boolean;
  email_system: boolean;
  notifications: boolean;
  document_generation: boolean;
  integrations: boolean;
}

const defaultFlags: FeatureFlags = {
  organizations: false,
  advanced_payments: true,
  email_system: true,
  notifications: true,
  document_generation: true,
  integrations: true,
};

export function useFeatureFlags() {
  const [flags, setFlags] = useState<FeatureFlags>(defaultFlags);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFlags = () => {
      try {
        const savedConfig = localStorage.getItem('feature_flags');
        if (savedConfig) {
          const config = JSON.parse(savedConfig);
          setFlags(prev => ({
            ...prev,
            ...config
          }));
        }
      } catch (error) {
        console.error('Error loading feature flags:', error);
      } finally {
        setLoading(false);
      }
    };

    loadFlags();

    // Écouter les changements de localStorage
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'feature_flags') {
        loadFlags();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const isEnabled = (feature: keyof FeatureFlags): boolean => {
    return flags[feature];
  };

  const updateFlag = (feature: keyof FeatureFlags, enabled: boolean) => {
    const newFlags = { ...flags, [feature]: enabled };
    setFlags(newFlags);
    localStorage.setItem('feature_flags', JSON.stringify(newFlags));
  };

  return {
    flags,
    isEnabled,
    updateFlag,
    loading
  };
}